import { useCallback, useEffect, useMemo, useState } from 'react';
import { get } from '@alltrails/shared/api';
import FeatureEntitlement from '../../types/FeatureEntitlement';
import User from '../../types/User';

const useFeaturePreviewEligibility = (feature: FeatureEntitlement, user: User | null) => {
  const [isEligible, setIsEligible] = useState<boolean>(); // Undefined signifies that we aren't sure yet

  useEffect(() => {
    async function getEligibility() {
      if (user) {
        try {
          const { users } = await get<{ users: { previewFeatureEntitlements?: FeatureEntitlement[] }[] }>('/api/alltrails/me');
          if (users.length) {
            const { previewFeatureEntitlements } = users[0];
            setIsEligible(Boolean(previewFeatureEntitlements?.includes(feature)));
          }
          // eslint-disable-next-line unused-imports/no-unused-vars
        } catch (error) {
          setIsEligible(false);
        }
      }
    }
    getEligibility();
  }, [feature, user]);

  const markIneligible = useCallback(() => {
    setIsEligible(false);
  }, []);

  return useMemo(() => ({ isEligible, markIneligible }), [isEligible, markIneligible]);
};

export default useFeaturePreviewEligibility;
